import { AlertTriangle, Repeat2, Users } from 'lucide-react'
import { Card } from '@/components/ui'
import { formatNumber } from '@/lib/utils'

interface ClientLifecycleKpiStripProps {
  /** Сколько человек заходило в студию за период (хотя бы один визит). */
  visitedClients: number
  /** Клиенты с целевой частотой: в среднем не меньше одного визита в неделю. */
  regularClients: number | null
  /** Период ещё идёт — числа неполные, подписываем это прямо на карточке. */
  periodInProgress: boolean
  daysElapsed: number
  daysTotal: number
  churnRiskCount: number
  idleDaysMin: number
  idleDaysMax: number
}

export function ClientLifecycleKpiStrip({
  visitedClients,
  regularClients,
  periodInProgress,
  daysElapsed,
  daysTotal,
  churnRiskCount,
  idleDaysMin,
  idleDaysMax,
}: ClientLifecycleKpiStripProps) {
  const items = [
    {
      key: 'visited' as const,
      label: 'Клиентов посетило',
      icon: Users,
      value: formatNumber(visitedClients),
      hint: periodInProgress ? `период идёт: ${daysElapsed} из ${daysTotal} дн.` : 'за период',
    },
    {
      key: 'frequency' as const,
      label: 'Ходят регулярно',
      icon: Repeat2,
      value: regularClients == null ? '—' : formatNumber(regularClients),
      hint: regularClients == null ? 'нет данных' : 'в среднем 1 визит в неделю',
    },
    {
      key: 'churn' as const,
      label: 'Нужно вернуть',
      icon: AlertTriangle,
      value: formatNumber(churnRiskCount),
      hint: `не ходят ${idleDaysMin}–${idleDaysMax} дней`,
    },
  ]

  return (
    <div className="grid grid-cols-2 gap-2 lg:grid-cols-3">
      {items.map((item) => {
        const Icon = item.icon
        return (
          <Card key={item.key} className="h-full p-3">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <p className="truncate text-xs text-muted-foreground">{item.label}</p>
                  <p className="mt-1 text-xl font-semibold tabular-nums text-foreground sm:text-2xl">
                    {item.value}
                  </p>
                  <p className="mt-1 text-[11px] leading-tight text-muted-foreground">{item.hint}</p>
                </div>
                <span className="rounded-lg bg-primary/10 p-2 text-primary">
                  <Icon className="h-4 w-4" />
                </span>
              </div>
          </Card>
        )
      })}
    </div>
  )
}
